<template>
  <div class="elements">
    <div v-if="programs.length && !loadingSVG" class="row water-test">
      <app-sel
        v-model="programId"
        :label="$ml.get(`You can choose finished program with crop selected above to fill irrigation water values:`)"
        :items="programs"
        key-name="id"
        label-name="name"
        id="program-select__label"
      >
        <template v-slot="{ items }">
          <app-sel-opt v-for="item in items" :value="item" :key="item.id">
            <template>{{ item.name }}</template>
          </app-sel-opt>
        </template>
      </app-sel>
    </div>

    <LoadingSVG v-if="loadingSVG" />
    

    <div v-if="!programs.length && !loadingSVG">
      {{$ml.get("You have no finished programs with crop you selected in 'Crop Info' stage")}}
    </div>
    <div v-if="programId && nutrients.length && !loadingSVG" class="row table-wrapper" ref="tableWrapper">
      <table 
      id="nutrients-table"
      :class="{disabled : load}"
      >
        <thead>
          <tr>
            <th>
              {{$ml.get('ELEMENT')}}
            </th>
            <th>
              {{$ml.get('Units')}}
            </th>
            <th>
              {{$ml.get('Irrigation Water')}}
            </th>
            <th>
              {{$ml.get('Drainage Analysis')}}
            </th>
            <th>
              {{$ml.get('Suggested values')}}
            </th>
          </tr>
        </thead>
        <tbody>
            <h3 class="drainage-row-header">
              {{ $ml.get(`N-Forms`) }}
            </h3>
            <NutrientItem
              v-for="item in nForms"
              :item="item"
              @showLoader="showLoader"
            />
            
            <h3 class="drainage-row-header">
              {{ $ml.get(`Nutrients`) }}
            </h3>
            <NutrientItem
             :item="totalN"
             :disabled="true"
            />

            <NutrientItem
              v-for="item in nuts"
              :item="item"
              v-if="item.Element != 'N'"
              @showLoader="showLoader"
            />

        </tbody>
      </table>

    </div>

    <!-- copy water test el list, but 3 values columns: drip, drain, result -->

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NutrientItem from './NutrientItem'
import LoadingSVG from '@/components/ui/LoadingSVG'
import API from '@/api';

export default {
  data() {
    return {
      items: [],
      nutrients: [],
      id: null,
      load: false,
      el: null
    }
  },
  components: {
    NutrientItem,
    LoadingSVG
  },

  watch: {
    '$route.params.id': {
      handler: function(id) {
        this.id = id;
        if(this.id != 'new' && this.programId)
          this.getNutrients();
        else
          this.programId = null
      },
    },

    'data.stageId': {
      handler: function(stageId) {
        const drainage = this.drainages.find(e => e.drainageId == this.data.drainageId)
        if(drainage && stageId == drainage.stageId && this.programId > 0) {
          this.setNutrients();
        } else if ((drainage && stageId != drainage.stageId && this.programId > 0) || this.$route.params.id == 'new') {
          this.getNutrients();
        } else if (!drainage) {
          this.getNutrients();
        }
      }
    }
  },

  created() {
    this.id = this.$route.params.id;
    this.getPrograms();

    if(this.data.drainageId != "new" && this.data.programId) {
      this.setNutrients();
    }
  },

  computed: {
    ...mapGetters({
      data: 'drainage/data',
      drainages: 'drainage/drainages',
      programs: 'drainage/programs',
      loadingSVG: 'drainage/getSVGLoading'
    }),

    programId: {
      get() {
        return this.data.programId
      },
      set(value) {
        if(value) {
          //set program ID
          this.$store.commit('drainage/setProgramId', value)
          this.getNutrients();
        }
      }
    },
    nForms() {
      return this.nutrients.filter(n => n.n_form == true)
    },
    nuts() {
      const filter = ['P', 'K', 'Ca', 'Mg', 'S', 'B', 'Fe', 'Mn', 'Zn', 'Cu', 'Cl', 'Mo', 'Na'];
      let nutrients = [];
      for(let i = 0; i < filter.length; i++) {
        const element = this.nutrients.find(e => e.Element == filter[i]);
        nutrients.push({DrainageAnalysis: element.DrainageAnalysis, Element: element.Element, IrrigationWater: element.IrrigationWater, TargetValues: element.TargetValues, n_form: element.n_form, types: element.types, units: element.units})
      }

      return nutrients.filter(n => n.n_form == false)
    },
    totalN() {
      let result = this.nutrients.find(e => e.Element == 'N')
      let nnh4 = this.nutrients.find(e => e.Element == 'NNH4')
      let nno3 = this.nutrients.find(e => e.Element == 'NNO3')

      console.log(result)

      if(nnh4.IrrigationWater && nno3.IrrigationWater) {
        result.IrrigationWater = nnh4.IrrigationWater + nno3.IrrigationWater;
        result.DrainageAnalysis = nnh4.DrainageAnalysis + nno3.DrainageAnalysis;
        result.TargetValues = nnh4.TargetValues + nno3.TargetValues;
      } else {
        nnh4.IrrigationWater = result.IrrigationWater * 0.2;
        nno3.IrrigationWater = result.IrrigationWater - nnh4.IrrigationWater;

        result.DrainageAnalysis = nnh4.DrainageAnalysis + nno3.DrainageAnalysis;
        result.TargetValues = nnh4.TargetValues + nno3.TargetValues;
      }

      return result
    }
  },

  methods: {
    showLoader({ loading, el }) {
      this.load = loading;
      this.el = el;
    },
    getPrograms() {
      this.$store.commit('drainage/setSVGLoading', true)

      this.$store.dispatch('drainage/getProgramsByCrop')
      .then(res => {
        let programs = [];
        res.data.data.forEach(e => {
          if(e.adjust != null) {
            programs.push(e)
          }
        })
        this.$store.commit('drainage/setPrograms', programs)
      })
      .finally(() => {this.$store.commit('drainage/setSVGLoading', false)})
    },
    getNutrients() {
      const nuts = this.$store.getters['drainage/getNutrients']
      this.nutrients.splice(0, this.nutrients.length)

          for(let nut in nuts) {
            if(nut != 'F_Val' && nut != 'CO3_Val' && nut != "NH2_Val" && nut != "Al") {

              let cutNut = nut == 'NO3_Val' || nut == 'NH4_Val' ? 'N' + nut.split('_Val')[0] : nut.split('_Val')[0]
              let termNut = cutNut == 'CL' ? this.$store.getters['nutrients/getNutrientByKey']("Cl") : this.$store.getters['nutrients/getNutrientByKey'](cutNut)

              this.nutrients.push({
                types: termNut.types,
                Element: termNut.key,
                units: termNut.units,
                n_form: termNut.n_form ? true : false,
                IrrigationWater: parseFloat(nuts[nut]),
                DrainageAnalysis: 0,
                TargetValues: 0          
              })

              
            }  
          }
          this.$store.commit('drainage/setNutrients', this.nutrients)
    },

    setNutrients(data = '') {
      if(!this.data.data) {
        let nutrients = [];

        const drainage = this.drainages.find(e => e.drainageId == this.data.drainageId);
        const nuts = this.$store.getters['drainage/getNutrients']

        for(let nut in nuts) {
          if(nut != 'F_Val' && nut != 'CO3_Val') {

            let cutNut = nut == 'NO3_Val' || nut == 'NH2_Val' || nut == 'NH4_Val' ? 'N' + nut.split('_Val')[0] : nut.split('_Val')[0]
            let termNut = cutNut == 'CL' ? this.$store.getters['nutrients/getNutrientByKey']("Cl") : this.$store.getters['nutrients/getNutrientByKey'](cutNut)
            let drainageNut = cutNut == 'CL' ? drainage.data.find(e => e.Element == 'Cl') : drainage.data.find(e => e.Element == cutNut)
                  
            nutrients.push({
              types: termNut.types,
              Element: termNut.key,
              units: termNut.units,
              n_form: termNut.n_form ? true : false,
              IrrigationWater: parseFloat(drainageNut.IrrigationWater),
              DrainageAnalysis: drainageNut.DrainageAnalysis,
              TargetValues: drainageNut.TargetValues         
            }) 
          }  
        }

        this.$store.commit('drainage/setNutrients', nutrients);
        this.nutrients = nutrients;
      } else {

        this.data.data.forEach(e => {
          let termNut = this.$store.getters['nutrients/getNutrientByKey'](e.Element)
          
          e.types = termNut.types;
          e.units = termNut.units;
          e.n_form = termNut.n_form ? true : false;
        });
        this.$store.commit('drainage/setNutrients', this.data.data)
        this.nutrients = this.data.data;
      }
      
      
    }
  }
}
</script>

<style lang="scss" scoped>
thead {
  border-bottom: 1px #d4d4d4 solid;
}
.elements {
  .water-test {
    padding-top: 32px;
  }
}

.table-wrapper {
  position: relative;
  #nutrients-table {
  width: 100%;
  border-collapse: collapse;
    th {
      padding: 30px 0 20px;
      text-transform: uppercase;
      color: #4C5056;
      text-align: left;
      padding-left: 14px;
    }
    &.disabled {
      pointer-events: none;
    }
  }
  
}

.app-sel {
  max-width: 400px;
}

.loading-svg {
  width: 25px;
  margin: 0 auto;
  display: block;
  &.table-loader {
    width: 40px;
    position: absolute;
    left: calc(50% - 20px);
    top: calc(50% - 20px);
    z-index: 33;
  }
}
.drainage-row-header {
  color: #4C5056;
  font-size: 15px;
  margin-left: 14px;
  padding: 8px 0 0px;
  margin-bottom: 0;
}
</style>
